(function ($) {
    'use strict';

    var validClass = 'success';
    var invalidClass = 'has-error';

    var validators = [];
    validators['text'] = [validateProvided, validatePattern];
    validators['email'] = [validateProvided, validatePattern, validateMatch];
    validators['file'] = [validateFile];
    validators['select-one'] = [validateProvided];
    validators['textarea'] = [validateProvided];
    validators['radio'] = [validateChecked];
    validators['checkbox'] = [validateChecked];
    validators['number'] = [validateProvided, validateNumberRange];
    validators['hidden'] = [validateProvided];

    /**
     * Checks if a required input is provided.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validateProvided($input) {
        var message = '';
        if ($input.prop('required')) {
            var value = $input.val() ? $input.val().trim() : $input.val();
            if (!value) {
                message = $input.data('required-message');
            }
        }
        return message;
    }

    /**
     * Checks if a valid email pattern is matched.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validatePattern($input) {
        var message = '';
        var value = $input.val();
        if (value) {
            var pattern = $input.data('pattern');
            if (pattern) {
                try {
                    var regex = new RegExp(pattern);
                    if (!regex.test(value.trim())) {
                        message = $input.data('validate-message');
                    }
                } catch (error) {
                    message = $input.data('validate-message');
                }
            }
        }
        return message;
    }

    /**
     * Checks if a text input matches a specified input's value.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validateMatch($input) {
        var message = '';
        var matchInputId = $input.data('match');
        if (matchInputId) {
            var $matchInput = $('#' + matchInputId);
            var isMatchInputValid = $matchInput.validate();

            if (!isMatchInputValid) {
                message = $input.data('validate-message');
            } else if ($matchInput.val() !== $input.val()) {
                message = $input.data('match-message');
            }
        }

        return message;
    }

    /**
     * Checks if a number input falls within a specified range.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validateNumberRange($input) {
        var message = '';
        var value = parseInt($input.val(), 10);

        if (!Number.isNaN(value)) {
            var min = parseInt($input.attr('min'), 10);
            var max = parseInt($input.attr('max'), 10);

            if (value < min || value > max) {
                message = $input.data('validate-message');
            }
        }

        return message;
    }

    /**
     * Checks if a file input meets the specified requirements.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validateFile($input) {
        var message = '';
        if ($input.prop('required') && $input[0].files.length === 0) {
            message = $input.data('required-message');
            return message;
        }

        if ($input[0].files.length === 1) {
            var size = $input[0].files[0].size;
            var maxSize = $input.data('filemaxsize');
            var maxSizeUnit = $input.data('filesizeunit');
            if (!isFileSizeValid(size, maxSize, maxSizeUnit)) {
                message = $input.data('validate-message');
            }
        }

        return message;
    }

    /**
     * Checks if a file size is valid based on the specified limits.
     * @param {number} size - The size of the file in bytes.
     * @param {number} maxSize - The maximum allowed size for the file.
     * @param {string} maxSizeUnit - The unit of the maximum allowed size (e.g., 'KB' or 'MB').
     * @returns {boolean} - True if the file size is valid, false otherwise.
     */
    function isFileSizeValid(size, maxSize, maxSizeUnit) {
        var sizeInKB = size / 1024;
        var sizeInMB = sizeInKB / 1024;
        var roundedSize =
            Math.round((maxSizeUnit == 'MB' ? sizeInMB : sizeInKB) * 100) / 100;
        var roundedMaxSize = Math.round(maxSize * 100) / 100;
        return roundedSize <= roundedMaxSize;
    }

    /**
     * Checks if a checkbox or radio input is checked.
     * @param {jQuery} $input - The input element to validate.
     * @returns {string} - The validation message if invalid, otherwise an empty string.
     */
    function validateChecked($input) {
        var message = '';
        if ($input.prop('required')) {
            var $form = $input.closest('form');
            var name = $input.attr('name');
            var valid = $form.find('[name="' + name + '"]').filter(':checked').length > 0;
            message = !valid ? $input.data('required-message') : message;
        }
        return message;
    }

    /**
     * Validates an input element.
     * @returns {boolean} - True if the input is valid, false otherwise.
     */
    $.fn.validate = function () {
        var $input = this;
        var isCustomOptionInput = $input.is('.form-group-custom-option__input');

        // Custom option validation should be skipped if not opted for ( ie visible )
        if (!isCustomOptionInput || (isCustomOptionInput && $input.is(':visible'))) {

            var $formGroup = $input.closest('.form-group');
            var validatorsToRun = validators[$input[0].type] || [];

            for (var i = 0; i < validatorsToRun.length; i++) {
                var message = validatorsToRun[i]($input);
                if (message) {
                    $formGroup.find('.validation-error span').text(message);
                    $formGroup.removeClass(validClass).addClass(invalidClass);

                    return false;
                }
            }

            if ($formGroup.hasClass(invalidClass)) {
                $formGroup.removeClass(invalidClass).addClass(validClass);
            }

            // Inputs that are valid but empty (optional) should be ignored.
            if ($formGroup.hasClass(validClass) && !$input.val()) {
                $formGroup.removeClass(validClass);
            }
        }

        return true;
    };

    /**
     * Resets an input element.
     */
    $.fn.resetInput = function () {
        var $input = this;
        var $formGroup = $input.closest('.form-group');
        $input.val('');
        $formGroup.removeClass(invalidClass).removeClass(validClass);
    }
})(jQuery);
